export const fixWorksPositioning = function (el) {
    fixThem(el);

    window.addEventListener("resize", function () {
        fixThem(el);
    });

    function fixThem(el) {
        if (window.innerWidth >= 768) {
            el.querySelectorAll(".items__item").forEach(function (theEl, i) {
                theEl.querySelector("p").setAttribute("style", "");
                if (i % 2 == 1) {
                    const thisH = theEl
                        .querySelector("p")
                        .getBoundingClientRect().height;
                    const thatH = theEl.previousElementSibling
                        .querySelector("p")
                        .getBoundingClientRect().height;
                    if (thisH != thatH) {
                        theEl.querySelector("p").style.height =
                            Math.max(thisH, thatH) + "px";
                        theEl.previousElementSibling.querySelector(
                            "p"
                        ).style.height = Math.max(thisH, thatH) + "px";
                    }
                }
            });
        } else {
            el.querySelectorAll(".items__item").forEach(function (theEl, i) {
                theEl.querySelector("p").setAttribute("style", "");
            });
        }
    }
};
